import { Divider, makeStyles } from '@material-ui/core';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { theme } from '../../../theme/theme';
import { Button, motions } from '../../global';
import { PlanCreationSections } from '../editor/InspectionCreationWizard';

const useInspectionPlanClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        '& > span': {
            color: theme.colors.darkBlue[5],
            ...theme.typography.headings.h3,
        },
    },
    scroll: {
        display: 'flex',
        overflow: 'auto',
        flex: '1 1 auto',
        height: 0,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
        marginTop: 20,
    },
});
export const Plan = () => {
    const classes = useInspectionPlanClasses();
    const { t } = usePrefixTranslation('asset', { asset: 'drawer.Plan' });
    const dispatch = useTypedDispatch();
    const { asset, plan } = useTypedSelector(state => ({ asset: state.asset, plan: state.plan }));
    const showButtons = !asset.fetching && !plan.fetching && (asset.changes.length > 0 || plan.changes.length > 0);

    if (!asset.asset || !plan.plan) return <span>{'#asset or plan not in store'}</span>;

    return (
        <div className={classes.root}>
            <span>{t('title')}</span>
            <Divider />
            <div className={classes.scroll}>
                <PlanCreationSections />
            </div>
            <Divider />
            <AnimatePresence>
                {showButtons && (
                    <motion.div className={classes.buttons} {...motions.presence({ pop: 10 })}>
                        <Button variant='outlined' onClick={() => dispatch(actions.asset.sharedDiscard(true))}>
                            {t('button-cancel')}
                        </Button>
                        <Button variant='outlined' onClick={() => dispatch(actions.asset.discard())}>
                            {t('button-undo')}
                        </Button>
                        <Button
                            variant='contained'
                            onClick={() => {
                                dispatch(actions.asset.sharedCommit());
                                dispatch(actions.asset.update());
                                dispatch(actions.plan.update());
                            }}
                        >
                            {t('button-save')}
                        </Button>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};
